import { computed as t, createElementBlock as v, openBlock as y, createElementVNode as d, normalizeClass as s, renderSlot as a } from "vue";
import n, { verticalOrientationsSet as h } from "../../constants/orientation.js";
const C = { class: "ds-width-full ds-height-full" }, p = /* @__PURE__ */ Object.assign({
  name: "DsMediaLayout"
}, {
  __name: "media-layout",
  props: {
    orientation: {
      type: String,
      default: n.right,
      validator: (l) => Object.values(n).includes(l)
    },
    mediaColumnsWidth: {
      type: Object,
      default: () => ({ small: 12, medium: 6, large: 6 }),
      validator: (l) => ["small", "medium", "large"].every((e) => e in l)
    },
    contentColumnsWidth: {
      type: Object,
      default: () => ({ small: 12, medium: 6, large: 5 }),
      validator: (l) => ["small", "medium", "large"].every((e) => e in l)
    },
    yAlign: {
      type: String,
      // All Media text blocks vertically center aligns the content.
      default: "center",
      validator: (l) => ["center", "stretch", "flex-end", "none"].includes(l)
    },
    yAlignWithScreen: {
      type: Object,
      // All Media text blocks vertically center aligns the content in different screen sizes
      default: null,
      // { small: 'flex-end', medium: 'center', large: 'flex-end'}
      validator: (l) => ["small", "medium", "large"].every((e) => e in l)
    },
    fullWidthMedia: {
      type: Boolean,
      default: !1
    },
    fullWidthContent: {
      type: Boolean,
      default: !1
    },
    centerAligned: {
      type: Boolean,
      default: !1
    },
    /**
     * To flip column orders on different screen sizes
     * Example use case: orientation === 'left' and
     * on md and/or sm screen sizes, desired look is media on the first row - content on the second row
     * then { ...props, orientation: 'left', isMdOnlyColumnReverse: true, isSmOnlyColumnReverse: true }
     */
    isMdOnlyColumnReverse: {
      type: Boolean,
      default: !1
    },
    isSmOnlyColumnReverse: {
      type: Boolean,
      default: !1
    },
    isLgOnlyColumnReverse: {
      type: Boolean,
      default: !1
    },
    isLgDownColumnReverse: {
      type: Boolean,
      default: !1
    }
  },
  setup(l) {
    const e = l, i = t(() => h.has(e.orientation)), r = t(() => e.orientation === n.left), m = t(() => e.orientation === n.bottom), u = t(() => i.value ? m.value ? "ds-flex-direction-column" : "ds-flex-direction-column-reverse" : ""), c = t(() => i.value ? e.fullWidthMedia ? "ds-md-grid__col--12" : "ds-md-grid__col--10" : `ds-md-grid__col--${e.mediaColumnsWidth.medium} ds-lg-grid__col--${e.mediaColumnsWidth.large}`), g = t(() => i.value ? e.fullWidthContent ? "ds-md-grid__col--12" : "ds-md-grid__col--8" : `ds-md-grid__col--${e.contentColumnsWidth.medium} ds-lg-grid__col--${e.contentColumnsWidth.large}`), f = t(() => e.yAlignWithScreen !== null ? `ds-align-items-${e.yAlign} ds-md-align-items-${e.yAlignWithScreen.medium} ds-lg-align-items-${e.yAlignWithScreen.large} ds-sm-align-items-${e.yAlignWithScreen.small}` : `ds-align-items-${e.yAlign}`);
    return (o, W) => (y(), v("div", C, [
      d("div", {
        class: s(["ds-grid ds-justify-content-space-between", [
          u.value,
          f.value,
          {
            "ds-flex-direction-row-reverse": r.value,
            "ds-md-only-flex-direction-column-reverse": l.isMdOnlyColumnReverse,
            "ds-sm-only-flex-direction-column-reverse": l.isSmOnlyColumnReverse,
            "ds-lg-only-flex-direction-column-reverse": l.isLgOnlyColumnReverse,
            "ds-lg-down-flex-direction-column-reverse": l.isLgDownColumnReverse
          }
        ]]),
        "data-j-container": ""
      }, [
        d("div", {
          class: s(["ds-grid__col ds-display-flex ds-flex-direction-column", [
            `ds-grid__col--${l.contentColumnsWidth.small}`,
            g.value,
            { "ds-justify-content-center": l.centerAligned }
          ]]),
          "data-j-column": ""
        }, [
          a(o.$slots, "content")
        ], 2),
        d("div", {
          class: s(["ds-grid__col", [
            `ds-grid__col--${l.mediaColumnsWidth.small}`,
            c.value
          ]]),
          "data-j-column": ""
        }, [
          a(o.$slots, "media")
        ], 2)
      ], 2)
    ]));
  }
});
export {
  p as default
};
